import type { SimulatorElementValue } from '@vedalib/editor/lib/elements'
import { FileUsageSource, ObjectFitEnum } from '@vedalib/editor/lib/files'
import lodash from 'lodash'

import { t } from 'services/Translation'

interface ICreateNewItemProps {
  itemId: string
  fileId: string
}

export const createNewItem = ({ itemId, fileId }: ICreateNewItemProps) => {
  return {
    label: `${t('elements.simulator.form.item')}`,
    value: itemId,
    image: {
      id: fileId,
      objectFit: ObjectFitEnum.cover,
      source: FileUsageSource.file,
    },
    overlay: null,
  }
}

export const sanitizedValue = (value: SimulatorElementValue) => {
  const itemIds = value.items.map((item) => item.value)
  let hasChanges = false
  const update = {
    ...value,
    items: value.items.map((item) => {
      const updatedAreas = item.areas?.map((area) => {
        if (area.itemId && !itemIds.includes(area.itemId)) {
          hasChanges = true
          return lodash.omit(area, 'itemId')
        }
        return area
      })
      return {
        ...item,
        areas: updatedAreas,
      }
    }),
  }

  return { hasChanges, update }
}

const PADDING_BOTTOM = 12
export const getAreaHeightInPixels = (areaHeight: number | string, container: number | string) => {
  const percent =
    typeof areaHeight === 'string' ? parseFloat(areaHeight.replace('%', '')) : areaHeight

  const containerHeight = typeof container === 'string' ? parseFloat(container) : container

  return (percent / 100) * containerHeight + PADDING_BOTTOM
}

export const getViewedCount = (items: Record<string, boolean>): number => {
  return lodash.filter(lodash.values(items), Boolean).length
}
